import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import Folders from "./Folders";
import FolderSkeleton from "./FolderSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { handleDisableFilter } from "~/Pages/Process/actions/attachmentsSlice";
import AttachmentTable from "~/Pages/EmployeeRegistry/components/Attachments/AttachmentTable";
import { formatDate } from "~/utils/CSVFunctions";
import SearchFIles from "./SearchFIles";

const EntityDocuments = () => {
  const { id } = useParams();
  const {
    handleClickService,
    states,
    handleClickServiceProcess,
    handleClickServiceSubFolder,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
  } = useFileDocuments({ id });

  const [attachmentConfirmModal, setAttachmentConfirmModal] = useState(false);
  const [temporaryMessage, setTemporaryMessage] = useState("");
  const [isAttachmentLoader, setIsAttachmentLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [restoreMessage, setRestoreMessage] = useState("");
  const [relatedId, setRelatedId] = useState("");
  const handleDeleteDocument = (file) => {
    setAttachmentConfirmModal(true);
    setSelectedFile(file);
  };
  const dispatch = useDispatch();
  const { blobFilterStates } = useSelector((state) => state.attachments);
  useEffect(() => {
    dispatch(handleDisableFilter(false));
  }, []);
  return (
    <div className="folders-container">
      {states?.folders?.length > 0 && (
        <p className="document-sub-heading">
          {blobFilterStates?.selectedItems?.length
            ? "Matching Files"
            : "Folders"}
        </p>
      )}

      {states.loading ? (
        <FolderSkeleton />
      ) : blobFilterStates?.selectedItems?.length ? (
        <SearchFIles
          fileName={fileName}
          setFileName={setFileName}
          additionaltag={{ entity: [states?.entity_detail?.name] }}
          states={states}
          first={first}
          rows={rows}
          onPageChange={onPageChange}
          isRootFolder={true}
        />
      ) : (
        <Folders folders={states?.folders} onFolderClick={handleClickService} />
      )}
    </div>
  );
};

export default EntityDocuments;
